export default "__VITE_ASSET__cwt54kIM__"